import React from 'react'

import validation from '../../../validation'

import LinkedProvidersSection from './LinkedProvidersSection'

export default {
  name: 'Treatment Providers',
  group: 'Providers',
  validationSchema: validation.object({}),
  Component: ({ caseModel, caseNumber, setModelValue }) => {
    /* eslint-disable no-console */
    const cId =
      caseNumber || (caseModel ? caseModel.caseNumber || caseModel.CaseNumber || caseModel.id || caseModel.Id : 'N/A')

    return (
      <LinkedProvidersSection
        caseId={cId}
        type="Treatment"
        title="Treatment Providers"
        setModelValue={setModelValue}
        caseModel={caseModel}
      />
    )
  },
}
